import React, { useEffect, useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet'
import { REACT_APP_URL, PROJECT_LIST_V2 } from 'config/env'
import { useHistory } from 'react-router-dom'

const ProjectListV2Page = () => {
  const history = useHistory()

  useLayoutEffect(() => {
    const content = document.querySelector('.contentlazy')
    if (!content) return undefined
    content.classList.add('contentlazy-project-list')
    return () => content.classList.remove('contentlazy-project-list')
  }, [])

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== `${REACT_APP_URL}`) return
      if (event.data.action === 'openTaskInbox') {
        window.open(
          `${REACT_APP_URL}/taskinbox/${event.data.project_id}/${event.data.task_id}/update/`,
          '_blank',
        )
      }
      if (event.data.action === 'openProjectQuickUpdate') {
        history.push(`/project/${event.data.project_id}/quick-update/`)
      }
      if (event.data.action === 'openHelpdeskInApp') {
        history.push('/helpdesk')
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  /*
   * The tab title used to come from `projectList.components.js`, which this page replaces when
   * PROJECT_LIST_V2 is on — without this the tab keeps whatever the previous route set.
   */
  return (
    <>
      <Helmet>
        <title>AXONS PROJECT | Project List</title>
      </Helmet>
      <iframe
        src={`${REACT_APP_URL}${PROJECT_LIST_V2 ? '/v2/project-list' : '/v2/gantt-view'}`}
        style={{
          border: 'none',
          display: 'block',
          width: '100%',
          /* 56px header + 28px padding-top of `.contentlazy` (Layout.scss) — without the 28px
             the frame runs past the viewport and hides the table's bottom scrollbar. */
          height: 'calc(100vh - 56px - 28px)',
        }}
      />
    </>
  )
}

export default ProjectListV2Page
